import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from 'recharts';

const EMPTY_TEXT = 'No activity in this range';

const PLATFORM_COLORS = {
  Android: '#3ddc84',
  iOS: '#8e8e93',
};

const TooltipContent = ({ active, payload }) => {
  if (!active || !payload || payload.length === 0) return null;
  const row = payload[0]?.payload;
  if (!row) return null;
  return (
    <div className="wa-chart-tooltip">
      <div className="wa-chart-tooltip-title">{row.label}</div>
      <div className="wa-chart-tooltip-row">
        <span>Platform</span>
        <strong>{row.platform}</strong>
      </div>
      <div className="wa-chart-tooltip-row">
        <span>Count</span>
        <strong>{row.count}</strong>
      </div>
    </div>
  );
};

TooltipContent.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
};

const EventTypeBar = ({ data }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return <div className="wa-chart-empty">{EMPTY_TEXT}</div>;
  }

  const sorted = [...data].sort((a, b) => b.count - a.count);

  return (
    <div className="wa-chart" data-testid="event-type-bar-chart">
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={sorted} margin={{ top: 10, right: 20, left: 0, bottom: 40 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eef0f3" />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11 }}
            interval={0}
            angle={-30}
            textAnchor="end"
            height={60}
          />
          <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
          <Tooltip content={<TooltipContent />} cursor={{ fill: 'rgba(245, 133, 89, 0.08)' }} />
          <Bar dataKey="count" isAnimationActive={false}>
            {sorted.map((row) => (
              <Cell key={`${row.platform}-${row.code}-${row.label}`} fill={PLATFORM_COLORS[row.platform] || '#f58559'} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

EventTypeBar.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      code: PropTypes.string,
      platform: PropTypes.string,
      count: PropTypes.number.isRequired,
    })
  ),
};

export default EventTypeBar;
